// Angular
import { Component, ElementRef, HostListener, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'kt-pdf-view',
  templateUrl: './pdf-view.html',
  styleUrls: ['./pdf-view.scss'],
})
export class PdfViewDialogComponent {
  // Public properties
  viewLoading = false;
  @ViewChild('confirmButton') confirmButton: ElementRef;
  @ViewChild('cancelButton') cancelButton: ElementRef;
  focusedButton = 'confirm';
  url = '';

  constructor(
    public dialogRef: MatDialogRef<PdfViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  @HostListener('window:keydown.enter', ['$event'])
  @HostListener('window:keydown.arrowleft', ['$event'])
  @HostListener('window:keydown.arrowright', ['$event'])
  onEnterKey(event: KeyboardEvent) {
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault(); // prevent default browser scrolling behavior
      this.focusedButton = this.focusedButton === 'confirm' ? 'cancel' : 'confirm';
    } else if (event.key === 'Enter') {
      if (this.focusedButton === 'confirm') {
        this.onYesClick();
      } else {
        this.onNoClick();
      }
    }
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }

  closeDialog() {
    this.dialogRef.close(true);
  }
}
